// Action Cable provides the framework to deal with WebSockets in Rails.
// You can generate new channels where WebSocket features live using the `bin/rails generate channel` command.

import { createConsumer } from "@rails/actioncable"

// Get phone_session_token from meta tag or localStorage
function getPhoneSessionToken() {
    // Try to get from meta tag first
    const metaTag = document.querySelector('meta[name="phone-session-token"]')
    if (metaTag) {
        return metaTag.getAttribute('content')
    }

    // Fallback to localStorage
    return localStorage.getItem('phone_session_token')
}

// Create consumer with authentication headers
const consumer = createConsumer()

// Override the createSubscription method to add authentication headers
const originalCreateSubscription = consumer.subscriptions.create
consumer.subscriptions.create = function (channelName, callbacks) {
    const phoneSessionToken = getPhoneSessionToken()

    // Add authentication headers
    if (phoneSessionToken) {
        consumer.connection.headers = {
            ...consumer.connection.headers,
            'PHONE_SESSION_TOKEN': phoneSessionToken
        }
    }

    return originalCreateSubscription.call(this, channelName, callbacks)
}

export default consumer
